import { Chip, withStyles } from '@material-ui/core';
import { neutral } from '../../../theme/colors';

export const MultiselectChip = withStyles({
  root: {
    margin: 2,
    backgroundColor: 'rgb(25, 135, 180)',
    color: neutral[100],
    '&:focus': {
      backgroundColor: 'rgba(25, 135, 180,.7)'
    },
    '& .MuiChip-deleteIcon': {
      color: neutral[100]
    }
  }
})(Chip);
